import React from 'react';

// 🏠 Kompletny katalog mebli i urządzeń - Styl Architektoniczny (Białe wypełnienie, czarny obrys)
// Zaktualizowano: Dodano zestawy kuchenne oraz stoły do salonu
export const FURNITURE_CATALOG = {
  // 🍴 KUCHNIA
  kitchen: {
    name: "Kuchnia",
    icon: "🍴",
    subcategories: {
      sets: {
        name: "Zestawy kuchenne",
        items: {
          kitchenSetI3: {
            id: "kitchen-set-i3",
            name: "Zestaw I (3 el.)",
            description: "Mały zestaw: Szafka, Kuchenka, Szafka",
            category: "kitchen",
            subcategory: "sets",
            dimensions: { width: 180, height: 85, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -90, y: -30, width: 60, height: 60 }, // Szafka
                { type: "rect", x: -30, y: -30, width: 60, height: 60 }, // Kuchenka
                { type: "rect", x: 30, y: -30, width: 60, height: 60 },  // Szafka
                { type: "circle", x: -15, y: -10, radius: 4 }, // Detal kuchenki
                { type: "circle", x: 15, y: -10, radius: 4 },
                { type: "circle", x: -15, y: 10, radius: 4 },
                { type: "circle", x: 15, y: 10, radius: 4 }
              ]
            },
            thumbnail: "🍱",
            metadata: { type: "set", elements: 3 }
          },
          kitchenSetI4: {
            id: "kitchen-set-i4",
            name: "Zestaw I (4 el.)",
            description: "Zestaw liniowy: Lodówka, Szafka, Kuchenka, Szafka",
            category: "kitchen",
            subcategory: "sets",
            dimensions: { width: 240, height: 85, depth: 65 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -120, y: -32.5, width: 60, height: 65 }, // Lodówka
                { type: "rect", x: -60, y: -30, width: 60, height: 60 },  // Szafka
                { type: "rect", x: 0, y: -30, width: 60, height: 60 },    // Kuchenka
                { type: "rect", x: 60, y: -30, width: 60, height: 60 },   // Szafka
                { type: "path", path: "M-110,-20 L-70,-20", strokeWidth: 2 } // Uchwyt lodówki
              ]
            },
            thumbnail: "🍱",
            metadata: { type: "set", elements: 4 }
          },
          kitchenSetL4: {
            id: "kitchen-set-l4",
            name: "Zestaw L (4 el.)",
            description: "Zestaw narożny: Szafka narożna, Kuchenka, Szafka, Lodówka",
            category: "kitchen",
            subcategory: "sets",
            dimensions: { width: 150, height: 85, depth: 150 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                // Narożnik (90x90)
                { type: "path", path: "M-75,-75 L15,-75 L15,-15 L75,-15 L75,75 L-75,75 Z" },
                // Kuchenka obok narożnika (prawa strona)
                { type: "rect", x: 15, y: -75, width: 60, height: 60 },
                // Szafka obok narożnika (dół)
                { type: "rect", x: -75, y: -15, width: 60, height: 60 }
              ]
            },
            thumbnail: "📐",
            metadata: { type: "set", elements: 4, shape: "L" }
          },
          kitchenSetL6: {
            id: "kitchen-set-l6",
            name: "Zestaw L (6 el.)",
            description: "Duży zestaw narożny z pełnym wyposażeniem",
            category: "kitchen",
            subcategory: "sets",
            dimensions: { width: 210, height: 85, depth: 150 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "path", path: "M-105,-75 L105,-75 L105,-15 L45,-15 L45,75 L-105,75 Z" }, // Blat L
                { type: "rect", x: 45, y: -75, width: 60, height: 60 }, // Kuchenka
                { type: "rect", x: -15, y: -75, width: 60, height: 60 }, // Zlew
                { type: "rect", x: -105, y: 15, width: 60, height: 60 }  // Lodówka
              ]
            },
            thumbnail: "📐",
            metadata: { type: "set", elements: 6, shape: "L" }
          },
          kitchenSetU6: {
            id: "kitchen-set-u6",
            name: "Zestaw U (6 el.)",
            description: "Zestaw w kształcie litery U",
            category: "kitchen",
            subcategory: "sets",
            dimensions: { width: 210, height: 85, depth: 210 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "path", path: "M-105,-105 L105,-105 L105,105 L45,105 L45,-45 L-45,-45 L-45,105 L-105,105 Z" }, // Blat U
                { type: "rect", x: -30, y: -105, width: 60, height: 60 }, // Kuchenka centralna
                { type: "rect", x: -105, y: 45, width: 60, height: 60 },  // Lodówka z lewej
                { type: "rect", x: 45, y: 45, width: 60, height: 60 }    // Zlew z prawej
              ]
            },
            thumbnail: "🍱",
            metadata: { type: "set", elements: 6, shape: "U" }
          },
          kitchenSetIsland: {
            id: "kitchen-set-island",
            name: "Zestaw z wyspą",
            description: "Zestaw liniowy z wyspą kuchenną",
            category: "kitchen",
            subcategory: "sets",
            dimensions: { width: 180, height: 85, depth: 150 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -90, y: -75, width: 180, height: 60 }, // Ciąg szafek
                { type: "rect", x: -60, y: 15, width: 120, height: 60 },  // Wyspa
                { type: "rect", x: -20, y: -70, width: 40, height: 40 }   // Zlew na szafkach
              ]
            },
            thumbnail: "🍱",
            metadata: { type: "set", island: true }
          }
        }
      },
      cabinets: {
        name: "Szafki",
        items: {
          baseCabinet60: {
            id: "kitchen-base-cabinet-60",
            name: "Szafka dolna 60cm",
            description: "Standardowa szafka kuchenna dolna",
            category: "kitchen",
            subcategory: "cabinets",
            dimensions: { width: 60, height: 85, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "🚪",
            metadata: { type: "base-cabinet", material: "wood", priceRange: "medium" }
          },
          baseCabinet80: {
            id: "kitchen-base-cabinet-80",
            name: "Szafka dolna 80cm",
            description: "Szafka dolna szeroka 80cm",
            category: "kitchen",
            subcategory: "cabinets",
            dimensions: { width: 80, height: 85, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "🚪",
            metadata: { type: "base-cabinet", material: "wood", priceRange: "medium" }
          },
          wallCabinet60: {
            id: "kitchen-wall-cabinet-60",
            name: "Szafka wisząca 60cm",
            description: "Szafka kuchenna wisząca",
            category: "kitchen",
            subcategory: "cabinets",
            dimensions: { width: 60, height: 70, depth: 35 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-mounted",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1, strokeDash: [5, 5] },
            thumbnail: "🗄️",
            metadata: { type: "wall-cabinet", material: "wood", priceRange: "medium" }
          },
          cornerCabinet: {
            id: "kitchen-corner-cabinet",
            name: "Szafka narożna",
            description: "Szafka narożna dolna (L-kształtna)",
            category: "kitchen",
            subcategory: "cabinets",
            dimensions: { width: 60, height: 85, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "path", 
              path: "M-42,-86 L128,-86 L128,76 L30,76 L30,0 L-42,0 Z", 
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1 
            },
            thumbnail: "📐",
            metadata: { type: "corner-cabinet", material: "wood", priceRange: "high" }
          }
        }
      },
      appliances: {
        name: "Sprzęt AGD",
        items: {
          fridgeStandard: {
            id: "kitchen-fridge-standard",
            name: "Lodówka",
            description: "Standardowa lodówka",
            category: "kitchen",
            subcategory: "appliances",
            dimensions: { width: 60, height: 185, depth: 65 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "❄️",
            metadata: { type: "fridge", energyClass: "A++", priceRange: "high" }
          },
          stoveGas: {
            id: "kitchen-stove-gas",
            name: "Kuchenka",
            description: "Kuchenka wolnostojąca",
            category: "kitchen",
            subcategory: "appliances",
            dimensions: { width: 60, height: 85, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group", 
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -30, y: -30, width: 60, height: 60 },
                { type: "rect", x: -24, y: -24, width: 48, height: 42 },
                { type: "circle", x: -18, y: 22, radius: 3 },
                { type: "circle", x:  -6, y: 22, radius: 3 },
                { type: "circle", x:   6, y: 22, radius: 3 },
                { type: "circle", x:  18, y: 22, radius: 3 }
              ]
            },
            thumbnail: "🔥",
            metadata: { type: "stove", fuelType: "gas", burners: 4, priceRange: "medium" }
          },
          sink: {
            id: "kitchen-sink",
            name: "Zlew",
            description: "Zlew jednokomorowy z ociekaczem",
            category: "kitchen",
            subcategory: "appliances",
            dimensions: { width: 80, height: 5, depth: 50 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-integrated",
            scalable: true,
            render2D: { 
              type: "path", 
              path: "M-40,-25 L40,-25 L40,25 L-40,25 Z M-35,-20 L0,-20 L0,20 L-35,20 Z", 
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1 
            },
            thumbnail: "🚰",
            metadata: { type: "sink", bowls: 1, material: "stainless-steel", priceRange: "low" }
          }
        }
      },
      furniture: {
        name: "Meble kuchenne",
        items: {
          kitchenIsland: {
            id: "kitchen-island",
            name: "Wyspa kuchenna",
            description: "Wyspa kuchenna z blatem",
            category: "kitchen",
            subcategory: "furniture",
            dimensions: { width: 120, height: 90, depth: 40 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "⏹️",
            metadata: { type: "island", includesStorage: true, priceRange: "high" }
          },
          diningTable: {
            id: "kitchen-dining-table",
            name: "Stół jadalniany",
            description: "Stół jadalniany prostokątny",
            category: "kitchen",
            subcategory: "furniture",
            dimensions: { width: 140, height: 75, depth: 80 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -70, y: -40, width: 140, height: 80 },
                { type: "rect", x: -42, y: -70, width: 30, height: 30 },
                { type: "rect", x: 10, y: -70, width: 30, height: 30 },
                { type: "rect", x: -42, y: 40, width: 30, height: 30 },
                { type: "rect", x: 10, y: 40, width: 30, height: 30 }
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "table", seats: 4, material: "wood", priceRange: "medium" }
          },
          chair: {
            id: "kitchen-chair",
            name: "Krzesło",
            description: "Krzesło standardowe",
            category: "kitchen",
            subcategory: "furniture",
            dimensions: { width: 45, height: 85, depth: 45 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -22.5, y: -22.5, width: 45, height: 45 },
                { type: "rect", x: -22.5, y: 15, width: 45, height: 5, fill: "#000000" }
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "chair", material: "wood", priceRange: "low" }
          }
        }
      }
    }
  },
  
  // 🛋️ SALON
  livingRoom: {
    name: "Salon",
    icon: "🛋️",
    subcategories: {
      seating: {
        name: "Siedzenia",
        items: {
          sofa2Seater: {
            id: "living-sofa-2-seater",
            name: "Sofa 2-osobowa",
            description: "Wygodna sofa 2-osobowa",
            category: "livingRoom",subcategory: "seating",
            dimensions: { width: 160, height: 85, depth: 90 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -80, y: -45, width: 160, height: 90 },
                { type: "rect", x: -80, y: -45, width: 160, height: 20 },
                { type: "rect", x: -80, y: -25, width: 20, height: 70 },
                { type: "rect", x: 60, y: -25, width: 20, height: 70 }
              ]
            },
            thumbnail: "🛋️",
            metadata: { type: "sofa", seats: 2, material: "fabric", priceRange: "medium" }
          },
          sofa3Seater: {
            id: "living-sofa-3-seater",
            name: "Sofa 3-osobowa",
            description: "Wygodna sofa 3-osobowa",
            category: "livingRoom",subcategory: "seating",
            dimensions: { width: 220, height: 85, depth: 90 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -110, y: -45, width: 220, height: 90 },
                { type: "rect", x: -110, y: -45, width: 220, height: 20 },
                { type: "rect", x: -110, y: -25, width: 20, height: 70 },
                { type: "rect", x: 90, y: -25, width: 20, height: 70 }
              ]
            },
            thumbnail: "🛋️",
            metadata: { type: "sofa", seats: 3, material: "fabric", priceRange: "high" }
          },
          sofaCorner: {
            id: "living-sofa-corner",
            name: "Sofa narożna",
            description: "Sofa narożna L-shape",
            category: "livingRoom",subcategory: "seating",
            dimensions: { width: 250, height: 85, depth: 180 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "path", path: "M-125,-90 L125,-90 L125,90 L35,90 L35,0 L-125,0 Z" },
                { type: "rect", x: -125, y: -90, width: 250, height: 20 },
                { type: "rect", x: 105, y: -70, width: 20, height: 160 },
                { type: "rect", x: -125, y: -70, width: 20, height: 70 },
                { type: "rect", x: 35, y: 70, width: 70, height: 20 }
              ]
            },
            thumbnail: "🛋️",
            metadata: { type: "sofa", seats: 5, material: "fabric", priceRange: "very-high" }
          },
          armchair: {
            id: "living-armchair",
            name: "Fotel",
            description: "Wygodny fotel",
            category: "livingRoom",subcategory: "seating",
            dimensions: { width: 90, height: 85, depth: 90 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
               type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -45, y: -45, width: 90, height: 90 },
                { type: "rect", x: -45, y: -45, width: 90, height: 20 },
                { type: "rect", x: -45, y: -25, width: 20, height: 70 },
                { type: "rect", x: 25, y: -25, width: 20, height: 70 }
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "armchair", seats: 1, material: "fabric", priceRange: "medium" }
          }
        }
      },
      tables: {
        name: "Stoły",
        items: {
          livingTableRect4: {
            id: "living-table-rect-4",
            name: "Stół prostokątny + 4 krzesła",
            description: "Komplet jadalniany dla 4 osób",
            category: "livingRoom",
            subcategory: "tables",
            dimensions: { width: 140, height: 75, depth: 120 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -70, y: -40, width: 140, height: 80 }, // Stół
                { type: "rect", x: -50, y: -60, width: 30, height: 20 }, // Krzesło góra L
                { type: "rect", x: 20, y: -60, width: 30, height: 20 },  // Krzesło góra R
                { type: "rect", x: -50, y: 40, width: 30, height: 20 },  // Krzesło dół L
                { type: "rect", x: 20, y: 40, width: 30, height: 20 }    // Krzesło dół R
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "table", seats: 4 }
          },
          livingTableRound4: {
            id: "living-table-round-4",
            name: "Stół okrągły + 4 krzesła",
            description: "Okrągły stół z 4 krzesłami",
            category: "livingRoom",
            subcategory: "tables",
            dimensions: { width: 120, height: 75, depth: 120 },
            rotation: 0,
            anchor: "center",
            collision: "circle",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "circle", x: 0, y: 0, radius: 45 }, // Stół
                { type: "rect", x: -15, y: -65, width: 30, height: 20 }, // Góra
                { type: "rect", x: -15, y: 45, width: 30, height: 20 },  // Dół
                { type: "rect", x: -65, y: -10, width: 20, height: 30 }, // Lewo
                { type: "rect", x: 45, y: -10, width: 20, height: 30 }   // Prawo
              ]
            },
            thumbnail: "⚪",
            metadata: { type: "table", seats: 4 }
          },
          livingTableRect6: {
            id: "living-table-rect-6",
            name: "Stół prostokątny + 6 krzeseł",
            description: "Duży stół jadalniany dla 6 osób",
            category: "livingRoom",
            subcategory: "tables",
            dimensions: { width: 180, height: 75, depth: 130 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -90, y: -45, width: 180, height: 90 }, // Stół
                { type: "rect", x: -75, y: -65, width: 30, height: 20 }, // Krzesła góra
                { type: "rect", x: -15, y: -65, width: 30, height: 20 },
                { type: "rect", x: 45, y: -65, width: 30, height: 20 },
                { type: "rect", x: -75, y: 45, width: 30, height: 20 }, // Krzesła dół
                { type: "rect", x: -15, y: 45, width: 30, height: 20 },
                { type: "rect", x: 45, y: 45, width: 30, height: 20 }
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "table", seats: 6 }
          },
          coffeeTable: {
            id: "living-coffee-table",
            name: "Stolik kawowy",
            description: "Prostokątny stolik kawowy",
            category: "livingRoom",subcategory: "tables",
            dimensions: { width: 100, height: 45, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "🪑",
            metadata: { type: "table", material: "wood", priceRange: "low" }
          },
          roundTable: {
            id: "living-round-table",
            name: "Stolik okrągły",
            description: "Okrągły stolik kawowy",
            category: "livingRoom",subcategory: "tables",
            dimensions: { width: 60, height: 45, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "circle",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "circle", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "⚪",
            metadata: { type: "table", material: "wood", priceRange: "low" }
          }
        }
      },
      entertainment: {
        name: "RTV",
        items: {
          tvStand: {
            id: "living-tv-stand",
            name: "Szafka RTV",
            description: "Szafka pod telewizor",
            category: "livingRoom",subcategory: "entertainment",
            dimensions: { width: 160, height: 45, depth: 45 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -80, y: -22.5, width: 160, height: 45 },
                { type: "rect", x: -20, y: -20, width: 40, height: 5, fill: "#000000" }
              ]
            },
            thumbnail: "📺",
            metadata: { type: "tv-stand", material: "wood", priceRange: "medium" }
          }
        }
      }
    }
  },

  // 🛌 SYPALNIA
  bedroom: {
    name: "Sypialnia",
    icon: "🛌",
    subcategories: {
      beds: {
        name: "Łóżka",
        items: {
          bedSingle: {
            id: "bedroom-bed-single",
            name: "Łóżko pojedyncze",
            description: "Łóżko 90x200cm",
            category: "bedroom",subcategory: "beds",
            dimensions: { width: 90, height: 85, depth: 200 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -45, y: -100, width: 90, height: 200 },
                { type: "rect", x: -45, y: -100, width: 90, height: 10 },
                { type: "rect", x: -35, y: -80, width: 70, height: 40 },
                { type: "rect", x: -45, y: 0, width: 90, height: 100, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 }
              ]
            },
            thumbnail: "🛏️",
            metadata: { type: "bed", size: "single", priceRange: "low" }
          },
          bedDouble: {
            id: "bedroom-bed-double",
            name: "Łóżko podwójne",
            description: "Łóżko 160x200cm",
            category: "bedroom",subcategory: "beds",
            dimensions: { width: 160, height: 85, depth: 200 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -80, y: -100, width: 160, height: 200 },
                { type: "rect", x: -80, y: -100, width: 160, height: 10 },
                { type: "rect", x: -70, y: -80, width: 60, height: 40 },
                { type: "rect", x: 10, y: -80, width: 60, height: 40 },
                { type: "rect", x: -80, y: 0, width: 160, height: 100, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 }
              ]
            },
            thumbnail: "🛏️",
            metadata: { type: "bed", size: "double", priceRange: "medium" }
          }
        }
      },
      storage: {
        name: "Przechowywanie",
        items: {
          wardrobe: {
            id: "bedroom-wardrobe",
            name: "Szafa",
            description: "Szafa ubraniowa 100cm",
            category: "bedroom",subcategory: "storage",
            dimensions: { width: 100, height: 220, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -50, y: -30, width: 100, height: 60 },
                { type: "path", path: "M-50,-30 L50,30 M50,-30 L-50,30", stroke: "#000000", strokeWidth: 0.5 }
              ]
            },
            thumbnail: "🚪",
            metadata: { type: "wardrobe", doors: 2, material: "wood", priceRange: "medium" }
          },
          bedsideTable: {
            id: "bedroom-bedside",
            name: "Stolik nocny",
            description: "Mały stolik nocny",
            category: "bedroom",subcategory: "storage",
            dimensions: { width: 40, height: 50, depth: 40 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "🪑",
            metadata: { type: "nightstand", drawers: 1, material: "wood", priceRange: "low" }
          }
        }
      }
    }
  },

  // 🚽 ŁAZIENKA
  bathroom: {
    name: "Łazienka",
    icon: "🚽",
    subcategories: {
      fixtures: {
        name: "Armatura",
        items: {
          toilet: {
            id: "bathroom-toilet",
            name: "WC",
            description: "Sedes kompaktowy",
            category: "bathroom",
            subcategory: "fixtures",
            dimensions: { width: 40, height: 80, depth: 70 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-integrated",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -20, y: -35, width: 40, height: 20 },
                { type: "path", path: "M-20,-15 L20,-15", strokeWidth: 1 },
                { type: "path", path: "M-20,-15 L20,-15 L20,15 Q20,35 0,35 Q-20,35 -20,15 Z", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "circle", x: 0, y: -25, radius: 4 }
              ]
            },
            thumbnail: "🚽",
            metadata: { type: "toilet", style: "modern", priceRange: "low" }
          },
          bathtub: { 
            id: "bathroom-bathtub",
            name: "Wanna",
            description: "Wanna prostokątna",
            category: "bathroom",subcategory: "fixtures",
            dimensions: { width: 170, height: 60, depth: 75 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-integrated",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -85, y: -37.5, width: 170, height: 75 },
                { type: "path", path: "M-65,-27.5 L65,-27.5 Q75,-27.5 75,-17.5 L75,17.5 Q75,27.5 65,27.5 L-65,27.5 Q-75,27.5 -75,17.5 L-75,-17.5 Q-75,-27.5 -65,-27.5 Z", strokeWidth: 1 },
                { type: "circle", x: 55, y: 0, radius: 3, fill: "#ffffff" },
                { type: "rect", x: -85, y: -5, width: 20, height: 10 }
              ]
            },
            thumbnail: "🛁",
            metadata: { type: "bathtub", material: "acrylic", priceRange: "medium" }
          },
          bathtubCorner: {
            id: "bathroom-bathtub-corner",
            name: "Wanna narożna",
            description: "Wanna narożna 140x140cm",
            category: "bathroom", subcategory: "fixtures",
            dimensions: { width: 140, height: 60, depth: 140 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "wall-integrated",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "path", path: "M-70,-70 L70,-70 Q70,70 -70,70 Z", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "ellipse", x: 0, y: 0, radiusX: 50, radiusY: 30, rotation: 45, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "circle", x: -10, y: -10, radius: 3, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 }
              ]
            },
            thumbnail: "🛁",
            metadata: { type: "bathtub", style: "corner", priceRange: "high" }
          },
          shower: {
            id: "bathroom-shower",
            name: "Prysznic",
            description: "Kabina prysznicowa kwadratowa",
            category: "bathroom",subcategory: "fixtures",
            dimensions: { width: 90, height: 200, depth: 90 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-integrated",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "rect", x: -45, y: -45, width: 90, height: 90 },
                { type: "rect", x: -40, y: -40, width: 80, height: 80 },
                { type: "path", path: "M40,-40 L40,40", strokeWidth: 1 },
                { type: "rect", x: 40, y: -5, width: 6, height: 10 },
                { type: "circle", x: 0, y: 0, radius: 5, strokeWidth: 1 }
              ]
            },
            thumbnail: "🚿",
            metadata: { type: "shower", enclosure: "glass", priceRange: "medium" }
          },
          sink: {
            id: "bathroom-sink",
            name: "Umywalka",
            description: "Umywalka ścienna",
            category: "bathroom",
            subcategory: "fixtures",
            dimensions: { width: 60, height: 85, depth: 45 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-integrated",
            scalable: true,
            render2D: { 
              type: "group",
              fill: "#ffffff", 
              stroke: "#000000", 
              strokeWidth: 1,
              elements: [
                { type: "path", strokeWidth: 1, path: "M-28,-20 L28,-20 Q30,-20 30,-18 L30,18 Q30,20 28,20 L-28,20 Q-30,20 -30,18 L-30,-18 Q-30,-20 -28,-20 Z" },
                { type: "circle", x: 0, y: 5, radius: 3 },
                { type: "path", strokeWidth: 1, path: "M-4,-25 L4,-25 L4,-10 Q4,-7 0,-7 Q-4,-7 -4,-10 Z" }
              ]
            },
            thumbnail: "🚰",
            metadata: { type: "sink", hasCabinet: false, priceRange: "low" }
          }
        }
      }
    }
  },

  // 💼 BIURO
  office: {
    name: "Biuro",
    icon: "💼",
    subcategories: {
      desks: {
        name: "Biurka",
        items: {
          deskRect: {
            id: "office-desk-rect",
            name: "Biurko proste",
            description: "Biurko 160x80cm",
            category: "office", subcategory: "desks",
            dimensions: { width: 160, height: 75, depth: 80 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: { type: "rect", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
            thumbnail: "🖥️",
            metadata: { type: "desk", material: "composite", priceRange: "medium" }
          },
          deskL: {
            id: "office-desk-l",
            name: "Biurko narożne",
            description: "Biurko L-kształtne 160x120cm",
            category: "office", subcategory: "desks",
            dimensions: { width: 160, height: 75, depth: 120 },
            rotation: 0,
            anchor: "center",
            collision: "poly",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "path",
              path: "M-80,-60 L80,-60 L80,0 Q20,0 20,60 L-80,60 L-80,-60 Z",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1
            },
            thumbnail: "📐",
            metadata: { type: "desk", material: "composite", priceRange: "high" }
          }
        }
      },
      chairs: {
        name: "Fotele",
        items: {
          officeChairStandard: {
            id: "office-chair-standard",
            name: "Fotel biurowy A",
            description: "Fotel z prostokątnym oparciem",
            category: "office", subcategory: "chairs",
            dimensions: { width: 60, height: 110, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "path", path: "M-20,-30 L20,-30 Q25,-30 25,-25 L25,-15 L-25,-15 L-25,-25 Q-25,-30 -20,-30 Z", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "rect", x: -25, y: -15, width: 50, height: 45, cornerRadius: 5, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "rect", x: -30, y: -10, width: 8, height: 35, cornerRadius: 2, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "rect", x: 22, y: -10, width: 8, height: 35, cornerRadius: 2, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 }
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "chair", style: "standard" }
          },
          officeChairRound: {
            id: "office-chair-round",
            name: "Fotel biurowy B",
            description: "Fotel kubełkowy/zaokrąglony",
            category: "office", subcategory: "chairs",
            dimensions: { width: 60, height: 110, depth: 60 },
            rotation: 0,
            anchor: "center",
            collision: "circle",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "path", path: "M-25,20 Q-30,20 -30,0 Q-30,-25 0,-25 Q30,-25 30,0 Q30,20 25,20 L20,20 Q25,20 25,0 Q25,-20 0,-20 Q-25,-20 -25,0 Q-25,20 -20,20 Z", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
                { type: "circle", x: 0, y: 0, radius: 18, fill: "#ffffff", stroke: "#000000", strokeWidth: 1 }
              ]
            },
            thumbnail: "🪑",
            metadata: { type: "chair", style: "modern" }
          }
        }
      }
    }
  },

  // ⚡ URZĄDZENIA
  devices: {
    name: "Urządzenia",
    icon: "⚡",
    subcategories: {
      electrical: {
        name: "Elektryczne",
        items: {
          socketDouble: {
            id: "device-socket-double",
            name: "Gniazdo 2x230V",
            description: "Gniazdo podwójne",
            category: "devices", subcategory: "electrical",
            dimensions: { width: 20, height: 20, depth: 10 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-mounted",
            scalable: true,
            render2D: {
              type: "group",
              fill: "none",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "circle", x: 0, y: 0, radius: 8 },
                { type: "path", path: "M-8,0 L8,0 M0,-8 L0,8" }
              ]
            },
            thumbnail: "🔌",
            metadata: { type: "socket", voltage: "230V" }
          },
          switchSingle: {
            id: "device-switch-single",
            name: "Włącznik",
            description: "Włącznik pojedynczy",
            category: "devices", subcategory: "electrical",
            dimensions: { width: 20, height: 20, depth: 10 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "wall-mounted",
            scalable: true,
            render2D: {
              type: "group",
              fill: "none",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                { type: "circle", x: 0, y: 0, radius: 8 },
                { type: "path", path: "M0,0 L12,-12 M12,-12 L8,-14 M12,-12 L14,-8" }
              ]
            },
            thumbnail: "🔘",
            metadata: { type: "switch" }
          }
        }
      }
    }
  },

  // 🌳 ZEWNĘTRZNE
  outdoor: {
    name: "Zewnętrzne",
    icon: "🌳",
    subcategories: {
      vehicles: {
        name: "Pojazdy",
        items: {
          carSedan: {
            id: "outdoor-car-sedan",
            name: "Samochód",
            description: "Samochód osobowy",
            category: "outdoor", subcategory: "vehicles",
            dimensions: { width: 180, height: 450, depth: 150 },
            rotation: 0,
            anchor: "center",
            collision: "box",
            placement: "free-standing",
            scalable: true,
            render2D: {
              type: "group",
              fill: "#ffffff",
              stroke: "#000000",
              strokeWidth: 1,
              elements: [
                 { type: "path", path: "M-85,-200 Q-90,-150 -90,0 Q-90,150 -85,200 Q-50,225 0,225 Q50,225 85,200 Q90,150 90,0 Q90,-150 85,-200 Q50,-225 0,-225 Q-50,-225 -85,-200 Z", strokeWidth: 1 },
                 { type: "path", path: "M-75,-80 Q0,-110 75,-80 L80,-40 Q0,-50 -80,-40 Z", strokeWidth: 1 },
                 { type: "path", path: "M-75,100 Q0,130 75,100 L78,60 Q0,70 -78,60 Z", strokeWidth: 1 },
                 { type: "path", path: "M-80,-40 L-78,60", strokeWidth: 1 },
                 { type: "path", path: "M80,-40 L78,60", strokeWidth: 1 }
              ]
            },
            thumbnail: "🚗",
            metadata: { type: "vehicle" }
          }
        }
      }
    }
  }
};

// 🎨 Kolory dla kategorii (używane tylko w UI katalogu)
export const CATEGORY_COLORS = {
  kitchen: "#f97316",
  livingRoom: "#3b82f6",
  bedroom: "#8b5cf6",
  bathroom: "#06b6d4",
  office: "#64748b",    
  devices: "#ef4444",   
  outdoor: "#22c55e",   
  hallway: "#84cc16",
  kidsRoom: "#ec4899",
  technical: "#6b7280"
};

// 🔍 Funkcje pomocnicze
export const getAllItems = () => {
  const allItems = [];
  Object.values(FURNITURE_CATALOG).forEach(category => {
    Object.values(category.subcategories).forEach(subcategory => {
      Object.values(subcategory.items).forEach(item => {
        allItems.push(item);
      });
    });
  });
  return allItems;
};

export const getItemById = (id) => {
  const allItems = getAllItems();
  return allItems.find(item => item.id === id);
};

export const searchItems = (query) => {
  const allItems = getAllItems();
  const lowercaseQuery = query.toLowerCase();
  return allItems.filter(item => 
    item.name.toLowerCase().includes(lowercaseQuery) || 
    item.description.toLowerCase().includes(lowercaseQuery) ||
    item.category.toLowerCase().includes(lowercaseQuery)
  );
};

export default FURNITURE_CATALOG;